import { debounce } from "./Util";

let $caseItem = $(".js-case-item");

const debounceOnScrollHeader = debounce(() => {
    const $header = $(".js-header");
    let prevScroll = App.W.scrollTop();
    let currentScroll;

    App.W.scroll(() => {
        currentScroll = App.W.scrollTop();
        const headerHidden = () => $header.hasClass("_header-hidden");

        if (
            (currentScroll > prevScroll && !headerHidden()) ||
            currentScroll > 0
        ) {
            $header.addClass("_header-hidden");
        }

        if (
            (currentScroll < prevScroll && headerHidden()) ||
            currentScroll <= 0
        ) {
            $header.removeClass("_header-hidden");
        }

        prevScroll = currentScroll;
    });
}, 50);

debounceOnScrollHeader();

if (App.W.width() >= 1024) {
    $caseItem.hover(function () {
        let $el = $(this);
        $el.addClass("_active");

        $el.find(".case-item--services li").each(function (index, el) {
            setTimeout(function () {
                $(el).addClass("_showed");
            }, index * 100);
        });
    });

    $caseItem.mouseleave(function () {
        let $el = $(this);
        $el.removeClass("_active");

        $el.find(".case-item--services li").each(function (index, el) {
            setTimeout(function () {
                $(el).removeClass("_showed");
            }, index * 150);
        });
    });

    let $caseLink = $(".js-big-case--product-list ul li a");
    let $servicesListElem = $(".js-big-case--product-list").find(
        ".js-case-services-list li"
    );

    $caseLink.hover(function () {
        let $el = $(this);
        let currentNum = $el.attr("data-num");

        $(".js-big-case--img-list")
            .find(`[data-num="${currentNum}"]`)
            .addClass("_active _z-index");

        setTimeout(() => {
            $(".js-big-case--img-list")
                .find("a:not(._active)")
                .removeClass("_active");
        }, 101);

        $caseLink.removeClass("_active");
        $el.addClass("_active");
        $el.closest(".js-big-case--product-list").addClass("_hide");
        $el.closest(".js-big-case--product-list")
            .find(".js-case-services-list")
            .addClass("_hide");

        $servicesListElem.each(function (idx, itm) {
            if ($(itm).attr("data-contain").indexOf(currentNum) >= 0) {
                $(itm).addClass("_active");
            }
        });
    });

    $caseLink.mouseleave(function () {
        let $el = $(this);
        let currentNum = $el.attr("data-num");
        $caseLink.removeClass("_active");

        setTimeout(() => {
            // $(".js-big-case--img-list")
            //     .find(`[data-num="${currentNum}"]`)
            //     .removeClass("_active");
            $(".js-big-case--img-list").find("a").removeClass("_active");
        }, 101);

        $(".js-big-case--img-list")
            .find(`[data-num="${currentNum}"]`)
            .removeClass("_z-index");

        setTimeout(() => {
            $(".js-big-case--img-list")
                .find(`[data-num="${currentNum}"]`)
                .removeClass("_active");
            // $(".js-big-case--img-list").find("a").removeClass("_active");
        }, 150);

        $el.closest(".js-big-case--product-list").removeClass("_hide");
        $el.closest(".js-big-case--product-list")
            .find(".js-case-services-list")
            .removeClass("_hide");

        $servicesListElem.removeClass("_active");
    });
}

let timingChange = $(".js-first-screen__title-items").attr("data-timing");
let timingDelayFirstStart = $(".js-first-screen__title-items").attr(
    "data-timing-first-start"
);
let lengthItems = $(".js-first-screen__title-item").length;

function changeMainItemsInterval($elem, interval) {
    $elem.each(function (index, item) {
        setTimeout(() => {
            if (index === 0) {
                $(item).addClass("_active");
            }
        }, timingDelayFirstStart);

        setTimeout(() => {
            $(".js-first-screen__title-item").removeClass("_active");
            $(item).addClass("_active");
        }, interval * index);
    });
}

function changeMainItems() {
    setInterval(() => {
        $(".js-first-screen__title-item").each(function (index, item) {
            setTimeout(() => {
                $(".js-first-screen__title-item").removeClass("_active");
                $(item).addClass("_active");
            }, timingChange * index);
        });
    }, timingChange * lengthItems);
}

if ($(".js-first-screen__title-items").length) {
    App.W.on("barba:afterEnter", () => {
        setTimeout(() => {
            changeMainItemsInterval(
                $(".js-first-screen__title-item"),
                timingChange
            );
        }, timingDelayFirstStart);

        setTimeout(() => {
            changeMainItems();
        }, timingDelayFirstStart);
    });
}

let swiperExpertiseBig = new Swiper(".js-expertise-big-slider", {
    effect: "fade",
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false
    },
    on: {
        init: function () {
            $('.js-expertise-big-slider').find(".swiper-slide:last").addClass("last-slide");
            $('.js-expertise-big-slider').find(".swiper-slide:first").addClass("first-slide");
            $('.js-expertise-big-slider').find(".swiper-slide-active").addClass("active-slide-visible");
        },
        slideChange: function () {
            // const lengthSlides = $(".js-expertise-big-slider").find(".swiper-wrapper").find(".swiper-slide").length / 2 - 1;
            // if (lengthSlides === $(".last-slide.swiper-slide-active").index()) {
                
            // }
            // if ($(".last-slide.swiper-slide-active").index() === 0) {
            //     $(".js-expertise-big-slider").find(".last-slide.swiper-slide-active").addClass('swiper-slide-prev');
            // }
            setTimeout(() => {
                $('.js-expertise-big-slider').find(".swiper-slide").removeClass("active-slide-visible");
                $('.js-expertise-big-slider').find(".swiper-slide-active").addClass("active-slide-visible");
            }, 1250);
        }
    }
});

let swiperExpertiseSmall = new Swiper(".js-expertise-small-slider", {
    effect: "fade",
    initialSlide: 1,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false
    },
     on: {
        init: function () {
            $('.js-expertise-small-slider').find(".swiper-slide:last").addClass("last-slide");
        }
    }
});

const $expertise = $('.expertise');

$(".expertise .swiper").hover(function () {
    const $el = $(this);
    $el.closest($expertise).find(".js-expertise-big-slider")[0].swiper.autoplay.stop();
    $el.closest($expertise).find(".js-expertise-small-slider")[0].swiper.autoplay.stop();
}, function () {
    const $el = $(this);
    $el.closest($expertise).find(".js-expertise-big-slider")[0].swiper.autoplay.start();
    $el.closest($expertise).find(".js-expertise-small-slider")[0].swiper.autoplay.start();
});

export function initialStreamSliders() {
    let swiperStream = new Swiper(".js-stream-slider", {
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: {
            el: ".js-stream-wrap-slider-pagination",
        },
    });

    let swiperStreamBtns = new Swiper(".js-stream-slider-btns", {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
            nextEl: ".js-stream-wrap-slider-btn-next",
            prevEl: ".js-stream-wrap-slider-btn-prev",
        },
        pagination: {
            el: ".js-stream-wrap-slider-pagination",
        },
    });
}

initialStreamSliders();

// let swiperRunLine = new Swiper(".js-runline-slider", {
//     slidesPerView: "auto",
//     spaceBetween: 80,
//     speed: 8000,
//     loop: true,
//     autoplay: {
//         enabled: true,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//         waitForTransition: false,
//     },
// });

$(".case-list a").hover(function () {
    let currentIndex = $(this).index();
    $(this)
        .closest(".multi-item")
        .find(".multi-item__hover")
        .eq(currentIndex)
        .addClass("_active");
});

$(".case-list a").mouseleave(function () {
    let currentIndex = $(this).index();
    $(this)
        .closest(".multi-item")
        .find(".multi-item__hover")
        .eq(currentIndex)
        .removeClass("_active");
});

$(".js-catalog-ticker").each(function (index) {
    let reverse = $(this).hasClass("js-catalog-ticker-reverse");
    let reverseParam = reverse ? "rtl" : "ltr";
    $(this).addClass(`js-ticker-${index}`);
    const slideQuantity = $(`.js-ticker-${index}`).find(
        ".splide__slide"
    ).length;
    new window.Splide(`.js-ticker-${index}`, {
        type: "loop",
        autoWidth: true,
        clones: slideQuantity * 2,
        direction: reverseParam,
        autoScroll: {
            pauseOnFocus: false,
            speed: 0.8,
        },
    }).mount(window.splide.Extensions);
});

$(".runline-slider__slide").on("mouseenter", function () {
    $(this).closest(".splide").addClass("_veiew-splide");
});

$(".runline-slider__slide").on("mouseleave", function () {
    $(this).closest(".splide").removeClass("_veiew-splide");
});

let sliderMenu = new Swiper(".js-menu-slider-cases", {
    effect: "fade",
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".slider-cases-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: ".slider-cases-button-next",
        prevEl: ".slider-cases-button-prev",
    },
});

$(".js-open-video-popup").click(function (e) {
    e.preventDefault();
    let video = $(this).attr("data-video");
    $(`[data-video-name='${video}']`).addClass("_active");
    $(`[data-video-name='${video}']`).find("video").trigger("play");
    App.H.addClass("_overlay");
});

$(".js-video-popup-close").click(function () {
    let $el = $(this);
    $el.closest(".js-video-popup").removeClass("_active");
    App.H.removeClass("_overlay");
    $el.siblings("video").trigger("pause");
});

$('.runline-slider__slide').hover(function () {
    $(this).closest(".splide").addClass("_active-splide");
    $(this).closest(".splide").siblings(".splide").addClass("_active-splide");
});

$('.runline-slider__slide').mouseleave(function () {
    $(this).closest(".splide").removeClass("_active-splide");
    $(this).closest(".splide").siblings(".splide").removeClass("_active-splide");
});

// $(".play-menu-showreel").click(function () {
//     $(".js-close-menu").trigger("click");
//     setTimeout(() => {
//         $("html,body")
//             .stop()
//             .animate(
//                 {
//                     scrollTop: $(".video-sticky").offset().top,
//                 },
//                 500
//             );

//         $(".js-sound-switch").trigger("click");
//     }, 150);
// });



// WEBPACK FOOTER //
// ./_src/js/modules/newMainPage.js